import React from "react";
import { message } from "antd";
import { EntityId } from "@reduxjs/toolkit";
import Card from "src/componets/Card";
import ListForm from "../../Products/_partials/_ListForm";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { updateProducts } from "src/actions/mine_craft/bundlesActions";
import { BundleInterface } from "src/store/mine_craft/bundlesSlice";
import {
  ProductInterface,
  selectProductEntities,
  selectProductIds,
} from "src/store/mine_craft/productsSlice";

interface dataInterface {
  products: ProductInterface[],
  bundle_id: number
}

const _Products = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const products = useAppSelector(selectProductEntities);
  const productsIds = useAppSelector(selectProductIds);

  if (!bundle) {
    return null;
  }

  const data: dataInterface = {
    products: [],
    bundle_id: bundle.id
  };

  productsIds.forEach((id: any) => {
    const product = products[id];

    if (product) {
      data.products.push(product);
    }
  });

  function onFinish(values: dataInterface) {
    handleSave(values).catch(console.error);
  }

  async function handleSave(result: dataInterface) {
    if (!bundle) {
      return;
    }

    const id = bundle.id;
    const newData: any = { products: [] };
    const resultIds: EntityId[] = result.products.map((product: any) => product.id);

    result.products.forEach((product: any) => {
      newData.products.push({
        id: product.id,
        productid: product.productid,
        amount: product.amount,
        price: product.price,
      });
    });

    productsIds.forEach((id: EntityId) => {
      if (!resultIds.includes(id)) {
        newData.products.push({
          id: id,
          _destroy: true
        });
      }
    });

    const resultAction = await dispatch(updateProducts({ bundleId: id, data: newData }));

    if (updateProducts.fulfilled.match(resultAction)) {
      message.success('Products updated successfully');
    }

    if (updateProducts.rejected.match(resultAction)) {
      const payload = resultAction.payload;
      const error = Array.isArray(payload) ? payload[0] : resultAction.error.message;
      message.error(error);
    }
  }

  return (
    <Card className='v-mb-20'>
      <h4 className='v-content-title'>Products</h4>

      <div style={{ maxWidth: 480 }}>
        <ListForm
          onFinish={onFinish}
          data={data}
        />
      </div>
    </Card>
  );
}

export default _Products;
